"use client";

import React, { useEffect } from "react";
import { MapPin, Mail, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
export default function Contacts() {
  useEffect(() => {
    // Oficjalny loader Cal.com (vanilla JS embed)
    (function (C, A, L) {
      let p = function (a, ar) {
        a.q.push(ar);
      };
      let d = C.document;
      C.Cal = C.Cal || function () {
        let cal = C.Cal;
        let ar = arguments;
        if (!cal.loaded) {
          cal.ns = {};
          cal.q = cal.q || [];
          d.head.appendChild(d.createElement("script")).src = A;
          cal.loaded = true;
        }
        if (ar[0] === L) {
          const api = function () {
            p(api, arguments);
          };
          const namespace = ar[1];
          api.q = api.q || [];
          if (typeof namespace === "string") {
            cal.ns[namespace] = cal.ns[namespace] || api;
            p(cal.ns[namespace], ar);
            p(cal, ["initNamespace", namespace]);
          } else p(cal, ar);
          return;
        }
        p(cal, ar);
      };
    })(window, "https://app.cal.com/embed/embed.js", "init");
    window.Cal("init", "konsultacja-bh-marketing", {
      origin: "https://cal.com"
    });
    window.Cal.ns["konsultacja-bh-marketing"]("inline", {
      elementOrSelector: "#cal-embed-konsultacja",
      config: {
        layout: "month_view",
        useSlotsViewOnSmallScreen: "true",
        theme: "light"
      },
      calLink: "bhmarketing/konsultacja-bh-marketing"
    });
    window.Cal.ns["konsultacja-bh-marketing"]("ui", {
      theme: "light",
      cssVarsPerTheme: {
        light: {
          "cal-brand": "#f72323"
        },
        dark: {
          "cal-brand": "#ffffff"
        }
      },
      hideEventTypeDetails: false,
      layout: "month_view"
    });
  }, []);
  return <section data-section-id="64821" id="formularz-kontaktowy" className="relative w-full bg-background text-foreground overflow-hidden pt-12 md:pt-16 pb-0">
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-[-10%] left-[-10%] w-[40%] h-[40%] bg-primary/5 rounded-lg blur-[120px]" />
        <div className="absolute bottom-[-10%] right-[-10%] w-[40%] h-[40%] bg-primary/5 rounded-lg blur-[120px]" />
      </div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">

        {/* ===== GŁÓWNA SEKCJA: KONSULTACJA / CAL.COM ===== */}
        <div className="mb-12 md:mb-20">
          <div className="mb-8 md:mb-10 text-center space-y-3 md:space-y-4">
            <h2 className="text-4xl sm:text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter text-primary uppercase">Umów Spotkanie</h2>
            <p className="text-muted-foreground max-w-2xl mx-auto font-medium !text-base px-2">Wybierz termin, który Ci pasuje - spotkanie potwierdzimy automatycznie. Skalujemy biznesy poprzez precyzyjne strategie marketingowe.</p>
          </div>
          <div className="rounded-lg border border-border bg-card shadow-2xl overflow-hidden">
            <div id="cal-embed-konsultacja" className="w-full min-h-[550px] md:min-h-[650px] overflow-auto" />
          </div>
        </div>

        {/* ===== 3 KAFELKI KONTAKTOWE ===== */}
        <div className="pb-12 md:pb-20">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 md:gap-6 lg:gap-10">

            <div className="flex flex-col items-center text-center gap-3 md:gap-4 p-6 md:p-8 rounded-lg bg-card border border-border shadow-sm hover:shadow-xl transition-shadow duration-300">
              <div className="flex h-12 w-12 md:h-14 md:w-14 shrink-0 items-center justify-center rounded-lg bg-accent border border-border text-primary shadow-sm">
                <MapPin className="h-6 w-6 md:h-7 md:w-7" />
              </div>
              <div>
                <h3 className="font-bold text-foreground text-base md:text-lg uppercase tracking-tight">Nasze Biuro</h3>
                <p className="text-muted-foreground mt-2 text-sm md:text-base">ul. Fabryczna 6,<br />53-609 Wrocław, Polska</p>
              </div>
            </div>

            <div className="flex flex-col items-center text-center gap-3 md:gap-4 p-6 md:p-8 rounded-lg bg-card border border-border shadow-sm hover:shadow-xl transition-shadow duration-300">
              <div className="flex h-12 w-12 md:h-14 md:w-14 shrink-0 items-center justify-center rounded-lg bg-accent border border-border text-primary shadow-sm">
                <Mail className="h-6 w-6 md:h-7 md:w-7" />
              </div>
              <div>
                <h3 className="font-bold text-foreground text-base md:text-lg uppercase tracking-tight">Email</h3>
                <Link to="mailto:kontakt@bhtechnologies.pl" className="text-muted-foreground hover:text-primary transition-colors mt-2 block font-medium text-sm md:text-base break-all">kontakt@bhtechnologies.pl</Link>
              </div>
            </div>

            <div className="flex flex-col items-center text-center gap-3 md:gap-4 p-6 md:p-8 rounded-lg bg-card border border-border shadow-sm hover:shadow-xl transition-shadow duration-300 sm:col-span-2 md:col-span-1">
              <div className="flex h-12 w-12 md:h-14 md:w-14 shrink-0 items-center justify-center rounded-lg bg-accent border border-border text-primary shadow-sm">
                <Phone className="h-6 w-6 md:h-7 md:w-7" />
              </div>
              <div>
                <h3 className="font-bold text-foreground text-base md:text-lg uppercase tracking-tight">Telefon</h3>
                <Link to="tel:+48500848890" className="text-muted-foreground hover:text-primary transition-colors mt-2 block font-medium text-sm md:text-base">+48 500 848 890</Link>
              </div>
            </div>
          </div>

          <div className="mt-8 md:mt-12 text-center px-2">
            <Link to="https://wa.me/+48500848890" newTab className="group relative inline-flex w-full sm:w-auto items-center justify-center gap-3 px-6 md:px-8 py-4 bg-primary hover:bg-primary/90 text-primary-foreground rounded-lg font-bold text-base md:text-lg transition-all duration-300 shadow-lg hover:-translate-y-1 uppercase tracking-wider">NAPISZ DO NAS NA WHATSAPP</Link>
          </div>
        </div>
      </div>

      {/* ===== MAPA NA PEŁNĄ SZEROKOŚĆ (ZAMKNIĘCIE SEKCJI) ===== */}
      <div className="relative w-full h-64 sm:h-80 md:h-96 border-t border-border">
        <iframe src="https://maps.google.com/maps?width=600&amp;height=400&amp;hl=en&amp;q=Wrocław, fabryczna 6&amp;t=&amp;z=13&amp;ie=UTF8&amp;iwloc=B&amp;output=embed" width="100%" height="100%" style={{
        border: 0
      }} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="BH Marketing Office" className="absolute inset-0" />
      </div>
    </section>;
}